(function () {
    'use strict';

    class SwifInputLeafletCtrl {
        constructor($scope, swifCartoLeafletService, swifFrameworkService, gettextCatalog) {
            this.$scope = $scope;
            this.service = swifCartoLeafletService;
            this.swif = swifFrameworkService;
            this.showLeaflet = false;
            this.translate = {
                'deletePoint': gettextCatalog.getString("Supprimer le point"),
                'zoomPoint': gettextCatalog.getString("Veuillez zoomer pour pouvoir placer le point de manière précise"),
                'centerPoint': gettextCatalog.getString("Placer le point au centre")
            }
        }
        $onInit() {
            var $ctrl = this;

            // TG-3477-VSN - get all site_categories for select
            $ctrl.isVSN = $ctrl.swif.settings.app.features.isVSN && $ctrl.viewpins;
            if (!$ctrl.isVSN) {
                $ctrl.showLeaflet = true
                this.initPositionMarker();
            }

            $ctrl.$scope.$watch('$parent.$parent.ngModel.site1', (newV) => {
                if($ctrl.isVSN && $ctrl.$scope.selectedMarker) {
                    if ($ctrl.$scope.selectedMarker.isPoint) {
                        $ctrl.$scope.selectedMarker.setIcon($ctrl.$scope.blue)
                    } else {
                        $ctrl.$scope.selectedMarker.setStyle({color: 'blue'})
                    }
                } else if($ctrl.isVSN && newV !== undefined && $ctrl.markerBySiteId && $ctrl.markerBySiteId[newV[0]]){
                    if ($ctrl.markerBySiteId[newV[0]].isPoint) {
                        $ctrl.markerBySiteId[newV[0]].setIcon($ctrl.$scope.orange)
                    } else {
                        $ctrl.markerBySiteId[newV[0]].setStyle({color: 'orange'})
                    }

                    $ctrl.$scope.selectedMarker = $ctrl.markerBySiteId[newV[0]]
                }
                // TG3941 - Display polygon AND his parents polygon if the selected site has it
                // The current site may does not have a polygon but we still want to display parent polygon
                if(!$ctrl.isVSN && newV) {
                    var filter = {fields: ['geo_point', 'geometry', 'osm_zoom', 'geo_polygon', 'site_parent_id']};

                    const addMarkerToMap = (sites) => {
                        this.service.removeLayerFromMap($ctrl.layer, $ctrl._map);

                        // Highlight the current site
                        var polygons = this.service.setChildAndParentsPolygons(sites);

                        $ctrl.layer = L.featureGroup(polygons);
                        $ctrl.layer.addTo($ctrl._map);

                        if (!_.isEmpty(polygons) && !this.ngModel) {
                            // We want to center the map to the child site (the last item)
                            var bounds = _.last(polygons).getBounds();
                            $ctrl._map.fitBounds(bounds)
                        }
                    }

                    this.swif.data.get('site', newV[0], filter).then( site => {
                        this.swif.data.callKw(
                            'site',
                            'get_parents_with_polygon',
                            [
                                [site.id]
                            ],
                            {
                                context: this.swif.user.getAuthenticatedUser().context
                            }
                        ).then(parent_sites => {
                            var sites_with_polygon = parent_sites.concat([site]);
                            addMarkerToMap(sites_with_polygon)
                        });
                    });
                } else {
                    // If the value is null, remove the previous layer
                    if($ctrl.layer) {
                        this.service.removeLayerFromMap($ctrl.layer, $ctrl._map);
                    }
                }
            });

            if ($ctrl.isVSN) {
                setTimeout(() => $ctrl.showLeaflet = true, 500)
                $ctrl.$scope.$watch('$ctrl.showLeaflet', (newV, oldV) => {
                    if (newV && oldV !== newV) {
                        $ctrl.initPositionMarker();
                        this._onInit()
                    }
                });

                $ctrl.allLayerCategories = [];
                $ctrl.allFamilyCategories = [];
                $ctrl.allSites = [];
                $ctrl.markerBySiteId =  [];
                $ctrl.selectedLayer = [];
                $ctrl.selectedFamily = [];

                $ctrl.getAllSiteCategories('is_layer').then(function(data) {
                    $ctrl.allLayerCategories = data;
                });
                $ctrl.getAllSiteCategories('is_family').then(function(data) {
                    $ctrl.allFamilyCategories = data;
                });

                $ctrl.$scope.$watch('$parent.$parent.ngModel.zoom', (newV) => {
                    if (this.$scope.$parent.$parent.ngModel && this.$scope.$parent.$parent.ngModel.id === undefined){
                        this._setMarkerOnInitMap()
                    }
                });
                $ctrl.$scope.$watchCollection('$ctrl.markerBySiteId', (newV) => {
                    if (newV) {
                        if ($ctrl._map && $ctrl.$scope.$parent.$parent.ngModel.site1){
                            const marker = $ctrl.markerBySiteId[$ctrl.$scope.$parent.$parent.ngModel.site1[0]]
                            if (marker && $ctrl.$scope.$parent.$parent.ngModel.changeSiteFromMap){
                                if (marker.isPoint && marker._latlng) {
                                    $ctrl._map.setView(marker._latlng, 20)
                                } else {
                                    $ctrl._map.fitBounds(marker.getBounds())
                                }
                            }
                        }
                    }
                });
            }
        }
        _onInit() {
            this.$scope.blue = L.AwesomeMarkers.icon({
                icon: 'info',
                markerColor: "blue",
                iconColor: 'white',
                prefix: 'fa'
            });
            this.$scope.orange = L.AwesomeMarkers.icon({
                icon: 'info',
                markerColor: "orange",
                iconColor: 'white',
                prefix: 'fa'
            });
        }
        // TG3762 - Add a draggable marker for the selected site
        _setMarkerOnInitMap() {
            var latlng = this.$scope.$parent.$parent.ngModel.latlng;
            if (this._map && latlng && !this.$scope.$parent.$parent.ngModel.changeSiteFromMap) {
                var parsedGeopoint = this.service.getLatLngFromPoint(latlng);
                this.setCenter({lat: parsedGeopoint[0], lng: parsedGeopoint[1]});
                this._map.setView(parsedGeopoint);
            }
        }
        _onMapInitialized(map) {
            this.onMapInitialized({map: map});
            this._map = map;
            this.initPositionMarker();
            if (!this.isVsn){
                this.keepZoom();
            }
            L.Control.geocoder().addTo(map);
        }
        setCenter(center) {
            center = center || this._map.getCenter();
            if (!this.marker) {
                this.addMarker(center);
            } else {
                // Changes the marker position to the given point
                this.marker.setLatLng(center);
            }
            this.ngModel = this.service.getPointFromLatLng(center.lat, center.lng);
            this.info = `Latitude : ${center.lat} | Longitude : ${center.lng}`;
        }
        deleteData() {
            this.ngModel = false;
            this._map.removeLayer(this.marker);
            delete this.marker;
            delete this.info;
        }
        onDragEnd(event) {
            this.setCenter(event.target._latlng);
        }
        initPositionMarker () {
            if (this._map && this.ngModel) {
                var latlng = this.service.getLatLngFromPoint(this.ngModel);
                this.addMarker(latlng);
                this._map.setView(latlng);
            }
        }
        addMarker(center) {
            let $ctrl = this
            function onDragEnd(data) {
                $ctrl.onDragEnd(data)
            }
            $ctrl.marker = L.marker(center, {
                draggable: true,
                zIndexOffset: 9999999
            }).addTo($ctrl._map)
            $ctrl.service.on('dragend', onDragEnd, $ctrl.marker, $ctrl.$scope)
        }

        keepZoom() {
            var $ctrl = this;
            $ctrl.zoom = $ctrl._map.getZoom();
            $ctrl.service.on('zoomend', function () {
                $ctrl.zoom = $ctrl._map.getZoom();
            }, $ctrl._map, $ctrl.$scope);
        }

        // on click set selected marker
        onClick(latlng, site, marker) {
            let $ctrl = this

            $ctrl.$scope.$apply(() => {
                $ctrl.$scope.$parent.$parent.ngModel.site1 = [site.id, site.name]
                $ctrl.$scope.$parent.$parent.ngModel.changeSiteFromMap = true
                $ctrl._setService(site)
            })

            marker.setIcon($ctrl.$scope.orange)
            $ctrl.$scope.selectedMarker = marker

            $ctrl.setCenter(latlng)
        }

        // on click set selected marker
        onClickLine(latlng, site, line) {
            let $ctrl = this

            $ctrl.$scope.$apply(() => {
                $ctrl.$scope.$parent.$parent.ngModel.site1 = [site.id, site.name]
                $ctrl.$scope.$parent.$parent.ngModel.changeSiteFromMap = true
                $ctrl._setService(site)
            })

            line.setStyle({color: 'orange'})
            $ctrl.$scope.selectedMarker = line

            $ctrl.setCenter(latlng)
        }

        // VSN - Set service from customField of site on attribut.key : Gestionnaire DEP
        _setService(site){
            let $ctrl = this;
            var filter = {};
            filter.limit = 0;
            filter.fields = ['custom_fields']
            var fieldToSearch = 'id';
            $ctrl.swif.data.addFilter(filter, fieldToSearch, '=', site.id);
            $ctrl.swif.data.searchRead('patrimoine_site', filter).then(function(data) {
                site.custom_fields = data.records[0].custom_fields || [];
                site.custom_fields.map((customField) => {
                    if (customField.key === 'Gestionnaire DEP') {
                        var filter = {};
                        filter.fields = ['id', 'name'];
                        $ctrl.swif.data.setLimit(filter, 1);
                        $ctrl.swif.data.addExtraFilter(filter, 'service', 'name', '=', customField.value);
                        $ctrl.swif.data.searchRead('department', filter).then(function(data) {
                            if (data.records && data.records.length > 0) {
                                let service = data.records[0];
                                $ctrl.$scope.$parent.$parent.ngModel.service_id = [service.id, service.name];
                            }
                        });
                    }
                });
            });
        }

        updateMarkers(){
            var $ctrl = this;
            if($ctrl.isVSN){
                $ctrl.markerBySiteId = {};
                var service = $ctrl.service;

                function getMarker(site) {
                    let icon = service.getIconFromSite(site);

                    let marker = service.getMarkerFromPoint(site.geo_point, {icon: icon});
                    marker.on('click', (e) => $ctrl.onClick(e.latlng, site, marker));
                    return marker;
                }

                function getLine(site) {
                    let myLine = JSON.parse(site.geo_line);

                    let polyline = L.polyline(myLine.coordinates, {color: 'blue'})
                    polyline.on('click', (e) => $ctrl.onClickLine(e.latlng, site, polyline));
                    return polyline;
                }

                function getMultiLine(site) {
                    let myMultiLine = JSON.parse(site.geo_multi_line);

                    let multiLine = L.multiPolyline(myMultiLine.coordinates, {color: 'blue'})
                    multiLine.on('click', (e) => $ctrl.onClickLine(e.latlng, site, multiLine));
                    return multiLine;
                }

                function getPolygon(site) {
                    let myPolygon = JSON.parse(site.geo_polygon);

                    let polygon = L.polygon(myPolygon.coordinates, {color: 'blue'})
                    polygon.on('click', (e) => $ctrl.onClickLine(e.latlng, site, polygon));
                    return polygon;
                }

                function getMultiPolygon(site) {
                    let myMultiPolygon = JSON.parse(site.geo_multi_polygon);

                    let multiPolygon = L.multiPolygon(myMultiPolygon.coordinates, {color: 'blue'})
                    multiPolygon.on('click', (e) => $ctrl.onClickLine(e.latlng, site, multiPolygon));
                    return multiPolygon;
                }

                service.removeLayerFromMap($ctrl.layer, $ctrl._map);

                let markers = [];
                let lines = [];
                let multiLines = [];
                let polygons = [];
                let multiPolygons = [];
                // TG-3474-VSN - iterate over all sites instead of initial collection
                let sitesList = $ctrl.allSites || [];

                sitesList.forEach(function (site) {
                    if (site.geo_line) {
                        let line = getLine(site);
                        if (line) {
                            lines.push(line);
                            $ctrl.markerBySiteId[site.id] = line;
                            $ctrl.markerBySiteId[site.id].isPoint = false;
                            $ctrl.markerBySiteId[site.id].isSelected = false;
                        }
                    } else if (site.geo_multi_line){
                        let multiLine = getMultiLine(site);
                        if (multiLine) {
                            multiLines.push(multiLine);
                            $ctrl.markerBySiteId[site.id] = multiLine;
                            $ctrl.markerBySiteId[site.id].isPoint = false;
                            $ctrl.markerBySiteId[site.id].isSelected = false;
                        }
                    } else if (site.geo_polygon){
                        let polygon = getPolygon(site);
                        if (polygon) {
                            polygons.push(polygon);
                            $ctrl.markerBySiteId[site.id] = polygon;
                            $ctrl.markerBySiteId[site.id].isPoint = false;
                            $ctrl.markerBySiteId[site.id].isSelected = false;
                        }
                    } else if (site.geo_multi_polygon){
                        let multiPolygon = getMultiPolygon(site);
                        if (multiPolygon) {
                            multiPolygons.push(multiPolygon);
                            $ctrl.markerBySiteId[site.id] = multiPolygon;
                            $ctrl.markerBySiteId[site.id].isPoint = false;
                            $ctrl.markerBySiteId[site.id].isSelected = false;
                        }
                    } else if (site.geo_point){
                        let marker = getMarker(site);
                        if (marker) {
                            markers.push(marker);
                            $ctrl.markerBySiteId[site.id] = marker;
                            $ctrl.markerBySiteId[site.id].isPoint = true;
                            $ctrl.markerBySiteId[site.id].isSelected = false;
                        }
                    }
                });

                // init selected marker
                if($ctrl.$scope.$parent.$parent.ngModel && $ctrl.$scope.$parent.$parent.ngModel.site1){
                    let marker = $ctrl.markerBySiteId[$ctrl.$scope.$parent.$parent.ngModel.site1[0]];
                    if(marker){
                        if (marker.isPoint) {
                            marker.setIcon($ctrl.$scope.orange);
                        } else {
                            marker.setStyle({color: 'orange'});
                        }
                        $ctrl.$scope.selectedMarker = marker;
                    }
                }

                if ($ctrl._map && markers.length > 0) {
                    var layerToAdd = L.featureGroup(markers);
                    $ctrl.layer = L.markerClusterGroup();
                    $ctrl.layer.options.spiderfyOnMaxZoom = false;
                    $ctrl.layer.options.disableClusteringAtZoom= 20;
                    $ctrl.layer.addLayer(layerToAdd);
                    $ctrl.layer.addTo($ctrl._map);
                    if ($ctrl.ngModel === undefined) {
                        $ctrl._map.fitBounds($ctrl.layer.getBounds());
                    }
                }

                if ($ctrl._map && lines.length > 0) {
                    var layerToAdd = L.featureGroup(lines);
                    $ctrl.layer = L.markerClusterGroup();
                    $ctrl.layer.addLayer(layerToAdd);
                    $ctrl.layer.addTo($ctrl._map);
                    if ($ctrl.ngModel === undefined) {
                        $ctrl._map.fitBounds($ctrl.layer.getBounds());
                    }
                }

                if ($ctrl._map && multiLines.length > 0) {
                    var layerToAdd = L.featureGroup(multiLines);
                    $ctrl.layer = L.markerClusterGroup();
                    $ctrl.layer.addLayer(layerToAdd);
                    $ctrl.layer.addTo($ctrl._map);
                    if ($ctrl.ngModel === undefined) {
                        $ctrl._map.fitBounds($ctrl.layer.getBounds());
                    }
                }

                if ($ctrl._map && polygons.length > 0) {
                    var layerToAdd = L.featureGroup(polygons);
                    $ctrl.layer = L.markerClusterGroup();
                    $ctrl.layer.addLayer(layerToAdd);
                    $ctrl.layer.addTo($ctrl._map);
                    if ($ctrl.ngModel === undefined) {
                        $ctrl._map.fitBounds($ctrl.layer.getBounds());
                    }
                }

                if ($ctrl._map && multiPolygons.length > 0) {
                    var layerToAdd = L.featureGroup(multiPolygons);
                    $ctrl.layer = L.markerClusterGroup();
                    $ctrl.layer.addLayer(layerToAdd);
                    $ctrl.layer.addTo($ctrl._map);
                    if ($ctrl.ngModel === undefined) {
                        $ctrl._map.fitBounds($ctrl.layer.getBounds());
                    }
                }

                if (markers.length === 0
                    && lines.length === 0 && multiLines.length === 0
                    && polygons.length === 0 && multiPolygons.length === 0
                    && $ctrl.ngModel === undefined) {
                    // when we don't have any marker or line or polygon, we set the view on the default geolocation
                    service.setDefaultCenterView($ctrl._map);
                }

                if (this.$scope.$parent.$parent.ngModel.id === undefined){
                    this._setMarkerOnInitMap();
                }else {
                    var latlng = this.service.getLatLngFromPoint(this.ngModel);
                    // May cause bug aka 'this._map is undefined' on instances with small DBs
                    // as long this function is triggered asynchronously
                    // cause the request could be finished before this._map from leaflet lib would be set
                    if (latlng) // TG3835 - Some inters or tasks can NOT have coordinates
                        this._map.setView(latlng)
                }
            }
        }

        // TG-3477-VSN - trigger default layer
        initDefault() {
            if (this.defaultOption.isLayer.length > 0) {
                this.getSitesLayer(this.defaultOption.isLayer[0].id, 'is_layer');
                this.selectedLayer = [this.defaultOption.isLayer[0].id, this.defaultOption.isLayer[0].name]
            }
        };

        // TG-3477-VSN - get all site_categories (= couches)
        getAllSiteCategories(layerType) {
            var $ctrl = this;
            var filter = {};
            $ctrl.defaultOption = {};
            filter.limit = 0;
            filter.fields = ['id', 'name'];
            $ctrl.swif.data.sortOn(filter, 'name');
            $ctrl.swif.data.addFilter(filter, layerType, '=', true);

            return this.swif.data.searchRead('site_category', filter).then(function(data) {
                if (layerType == 'is_layer') {
                    if ($ctrl.$scope.$parent.$parent.ngModel.site1){
                        let filterSite = {}
                        filterSite.limit = 1
                        filterSite.fields = ['id', 'name', 'type_id']
                        $ctrl.swif.data.addFilter(filterSite, 'id', '=', $ctrl.$scope.$parent.$parent.ngModel.site1[0])
                        $ctrl.swif.data.searchRead('site', filterSite).then(function(dataSite) {
                            const typeId = dataSite.records[0].type_id
                            const cat = data.records.filter((category) => category.name == typeId[1])
                            let catName = 'default'
                            if(cat && cat[0] && cat[0].name){
                                catName = cat[0].name
                            }
                            $ctrl.defaultOption.isLayer = data.records.filter((category) => category.name == catName)
                            $ctrl.initDefault()
                        })
                    } else {
                        $ctrl.defaultOption.isLayer = data.records.filter((category) => category.name == 'default')
                        $ctrl.initDefault()
                    }
                }
                return data.records;
            });
        }

        // TG-3477-VSN - get all sites from a site_category
        getSitesLayer(typeId, layerType) {
            var $ctrl = this;
            var filter = {};
            filter.limit = 0;
            filter.fields = [
                'geo_point',
                'geo_multi_point',
                'geo_line',
                'geo_multi_line',
                'geo_polygon',
                'geo_multi_polygon',
                'state',
                'name',
                'street',
                'zip',
                'city',
                'type_id',
                'service_names'];
            $ctrl.currentLayer = layerType;
            let fieldToSearch = $ctrl.currentLayer == 'is_layer' ? 'type_id' : 'type_ids';
            $ctrl.swif.data.addFilter(filter, fieldToSearch, '=', typeId);
            $ctrl.swif.data.searchRead('patrimoine_site', filter)
            .then(function(data) {
                $ctrl.allSites = data.records;
                $ctrl.updateMarkers();
            });
        }

        clearSelection(layerType) {
            this.allSites = []
            this.updateMarkers()

            let typeId
            if (layerType === 'is_layer') {
                typeId = this.selectedLayer ? this.selectedLayer[0] : 0
            } else {
                typeId = this.selectedFamily ? this.selectedFamily[0] : 0
            }

            this.getSitesLayer(typeId, layerType)
        }
    }
    SwifInputLeafletCtrl.$inject = ['$scope', 'swifCartoLeafletService', 'swifFrameworkService', 'gettextCatalog'];

    angular.module('swif.carto')

    .component('swifInputLeaflet', {
        template: `
        <div ng-if="$ctrl.showLeaflet">
            <div class="row col-md-12" ng-show="$ctrl.isVSN" ng-init="layer='is_layer'">
                <div class="form-group col-sm-6 col-md-6">
                    <label class="align-middle">
                        <input type="radio" value="is_layer"
                            ng-model="layer"
                            ng-change="$ctrl.clearSelection('is_layer')"
                        >
                            Couche
                        <span class="badge progress-bar-info"><span>{{ ($ctrl.currentLayer == 'is_layer') ? $ctrl.allSites.length : 0 }}</span></span>
                    </label>
                    <swif-input-select-one
                        ng-show="layer == 'is_layer'"
                        ng-model="$ctrl.selectedLayer"
                        choices="$ctrl.allLayerCategories"
                        swif-change="$ctrl.getSitesLayer($value.id, layer)"
                        swif-placeholder="-- Choisir une couche --">
                    </swif-input-select-one>
                </div>
                <div class="form-group col-sm-6 col-md-6">
                    <label>
                        <input type="radio" value="is_family"
                            ng-model="layer"
                            ng-change="$ctrl.clearSelection('is_family')"
                        >
                            Famille
                        <span class="badge progress-bar-info"><span>{{ ($ctrl.currentLayer == 'is_family') ? $ctrl.allSites.length : 0}}</span></span>
                    </label>
                    <swif-input-select-one
                        ng-show="layer == 'is_family'"
                        ng-model="$ctrl.selectedFamily"
                        choices="$ctrl.allFamilyCategories"
                        swif-change="$ctrl.getSitesLayer($value.id, layer)"
                        ng-disabled="readonly"
                        swif-placeholder="-- Choisir une famille --">
                    </swif-input-select-one>
                </div>
            </div>
            <swif-leaflet on-map-initialized="$ctrl._onMapInitialized(map)">
            </swif-leaflet>
            <p class="ng-hide help-block" ng-show="$ctrl.helpText">{{$ctrl.helpText}}</p>
            <div class="control-label">
                <div class="alert alert-warning" ng-show="$ctrl.zoom <= 10">
                    <p>{{$ctrl.translate.zoomPoint}}</p>
                </div>
                <div class="btn-group pull-right" ng-show="$ctrl.zoom > 10">
                    <button type="button "class="btn btn-xs btn-link"
                        ng-click="$ctrl.setCenter()">
                        <i class="fa fa-map-marker fa-fw"></i>
                        {{$ctrl.translate.centerPoint}}
                    </button>
                    <button type="button "class="btn btn-xs btn-danger"
                        ng-click="$ctrl.deleteData()"
                        ng-disabled="!$ctrl.marker">
                        <i class="fa fa-trash-o"></i>
                        {{$ctrl.translate.deletePoint}}
                    </button>
                    <button type="button "class="btn btn-xs btn-link"
                        ng-init="showInfo = false"
                        ng-click="showInfo = !showInfo"
                        ng-disabled="!$ctrl.marker">
                        <i class="fa fa-info"></i>
                    </button>
                </div>
                <p class="ng-hide" ng-show="showInfo">{{$ctrl.info}}</p>
            </div>
        </div>`,
        controller: SwifInputLeafletCtrl,
        bindings: {
            onMapInitialized: '&',
            ngModel: '=',
            helpText: '@',
            ngRequired: '=',
            viewpins: '<'
        }
    });

})();
